var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PDF',{attrs:{"src":_vm.$parent.parameters.source_path}})
}
var staticRenderFns = []

export { render, staticRenderFns }